export default "/images/logo.png?fd8513776ad0d2c8e937dc353caf3516";